import _ from 'lodash';
import { App } from '../features/home';
import { PageNotFound } from '../features/common';
import homeRoute from '../features/home/route';
import commonRoute from '../features/common/route';
import importRoute from '../features/import/route';
import templateRoute from '../features/template/route';
import pluginRoute from '../features/plugin/route';
import appSettingRoute from '../features/app-setting/route';
import dataConnectorRoute from '../features/data-connector/route';
import externalApiRoute from '../features/external-api/route';
import tutorialRoute from '../features/tutorial/route';
import collectionsRoute from '../features/collections/route';
import eventsRoute from '../features/events/route';
import projectOnBoardRoute from '../features/project-on-board/route';
import knowledgeBaseRoute from '../features/knowledge-base/route';
import webhookRoute from '../features/webhook/route';
import loggerRoute from '../features/logger/route';
import onBoardingRoute from '../features/on-boarding/route';
import scheduleRoute from '../features/schedule/route';
import customComponentRoute from '../features/custom-component/route';
import permissionRoute from '../features/permission/route';
import deploymentSettingRoute from '../features/deployment-setting/route';
import aiPromptBuilderRoute from '../features/ai-prompt-builder/route';

const childRoutes = [
  homeRoute,
  commonRoute,
  importRoute,
  templateRoute,
  pluginRoute,
  appSettingRoute,
  dataConnectorRoute,
  externalApiRoute,
  tutorialRoute,
  collectionsRoute,
  eventsRoute,
  projectOnBoardRoute,
  knowledgeBaseRoute,
  webhookRoute,
  loggerRoute,
  onBoardingRoute,
  scheduleRoute,
  customComponentRoute,
  permissionRoute,
  deploymentSettingRoute,
  aiPromptBuilderRoute,
];

const routes = [
  {
    path: '/',
    component: App,
    childRoutes: [
      ...childRoutes,
      { path: '*', name: 'Page not found', component: PageNotFound },
    ].filter((r) => r.component || (r.childRoutes && r.childRoutes.length > 0)),
  },
];

function handleIndexRoute(route) {
  if (!route.childRoutes || !route.childRoutes.length) {
    return;
  }

  const indexRoute = _.find(route.childRoutes, (child) => child.isIndex);
  if (indexRoute) {
    const first = { ...indexRoute };
    first.path = '';
    first.exact = true;
    first.autoIndexRoute = true;
    route.childRoutes.unshift(first);
  }
  route.childRoutes.forEach(handleIndexRoute);
}

routes.forEach(handleIndexRoute);
export default routes;
